﻿import {DateTime} from "@2d-front-monorepo/core";
import {
	ParkingPrebookingAvailabilityEntry,
	SelectedParkingPrebookingAvailabilityEntry
} from "../types/ParkingPrebookingAvailabilityEntry";
import {isDateRangeValid} from "./isDateRangeValid";
import {MultiOperationSegment} from "./MultiOperationSegment";

export class MultiOperationPermit implements Iterable<MultiOperationSegment> {
	private readonly _availability: ParkingPrebookingAvailabilityEntry[];
	private readonly _segments: MultiOperationSegment[];
	private readonly _unavailable: Set<string>;

	constructor(availability: ParkingPrebookingAvailabilityEntry[], unavailable: Set<string>) {
		this._availability = availability;
		this._unavailable = unavailable;
		this._segments = [];
	}

	get size(): number {
		return this._segments.length;
	}

	getSelected(): SelectedParkingPrebookingAvailabilityEntry[] {
		return this._segments.map(s => s.toPrebookingEntry());
	}

	at(index: number): MultiOperationSegment | undefined {
		return this._segments.at(index);
	}

	clear(): void {
		this._segments.length = 0;
	}

	remove(start: number, length: number = 0): void {
		this._segments.splice(start, length <= 0 ? Infinity : length);
	}

	tryCreateSegment(startDate: DateTime, endDate: DateTime): boolean {
		if (!isDateRangeValid(this._availability, startDate, endDate, this._unavailable)) {
			return false;
		}

		this._segments.push(new MultiOperationSegment(startDate, endDate));
		return true;
	}

	[Symbol.iterator](): Iterator<MultiOperationSegment> {
		let index = 0;
		const entries = this._segments;

		return {
			next: (): IteratorResult<MultiOperationSegment> => {
				if (index < entries.length) {
					return {value: entries[index++], done: false};
				} else {
					return {value: undefined, done: true};
				}
			}
		};
	}
}
